import { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import API from '../../api/api'
import { selectUserData } from '../../reducers/userDataReducer'

export class UserPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      message: '',
      formPending: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault()
    const userEmail = this.props.userData.user.email
    this.setState({ formPending: true, message: '' })
    API.recoverPassword(userEmail)
      .then(() => {
        this.setState({
          formPending: false,
          message: this.props.t('user-panel:password.resetSent'),
        })
      })
      .catch(() =>
        this.setState({
          formPending: false,
          message: this.props.t('user-panel:password.serverError'),
        }),
      )
  }

  render() {
    const { t } = this.props
    return (
      <div className="form form--object-profile">
        <form>
          <p className="field">{t('user-panel:password.description')}</p>
          <div className="field">
            <button
              type="submit"
              className={`button button-primary is-block ${
                this.state.formPending ? 'is-loading' : ''
              }`}
              onClick={this.handleSubmit}
            >
              {t('user-panel:password.resetButton')}
            </button>
          </div>
          <p className="help is-success">{this.state.message}</p>
        </form>
      </div>
    )
  }
}

UserPassword.propTypes = {
  userData: PropTypes.object.isRequired,
  t: PropTypes.func,
}

export default connect((state) => ({ userData: selectUserData(state) }))(
  withTranslation(['user-panel'])(UserPassword),
)
